<template>
    <div class="card">
        <div class="card-header">
            <h5 class="m-0">Artiklar per status</h5>
        </div>
        <div class="card-body">
            <apexcharts  width="100%" height="350"
                type="bar"
                :options="options"
                :series="series"></apexcharts>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        apexcharts: VueApexCharts
    },
    props : ['company'],
    data() {
        return {
            options: {
                plotOptions: {
                    bar: {
                        distributed: true,
                        endingShape: 'rounded',
                        horizontal: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: [],
                }
            },
            series: [{
                data: []
            }]
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        parseData(data){
            let options = this.options;

            data.map(post => {
                options.xaxis.categories.push(this.$t('status_' + post.status));
                
                this.series[0].name = "artiklar";
                this.series[0].data.push(post.count);
            });
        },
        async fetchData() {
            const { data } = await axios.get(
                "api/analytics/printables_by_status?company_id=" + this.company
            );

            this.parseData(data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/PrintableStatus.vue